function ReloadIcon({ width = 17, height = 17 }) {
    return (
        <svg
            width={`${width}`}
            height={`${height}`}
            viewBox="0 0 17 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M9.29858 2.89092C8.08212 2.71838 6.84253 2.94588 5.76661 3.53913C4.69068 4.13237 3.83672 5.05925 3.3334 6.18006C2.83009 7.30088 2.70468 8.55492 2.9761 9.75316C3.2475 10.9515 3.90102 12.0291 4.83815 12.8237C5.77529 13.6182 6.94529 14.0866 8.17183 14.1585C9.39837 14.2302 10.615 13.9013 11.6384 13.2215C12.6618 12.5416 13.4365 11.5476 13.8458 10.3891C13.9761 10.0202 14.3807 9.82686 14.7496 9.95716C15.1184 10.0875 15.3119 10.4922 15.1815 10.861C14.67 12.3091 13.7016 13.5516 12.4223 14.4015C11.1431 15.2513 9.62226 15.6624 8.08909 15.5727C6.55591 15.483 5.09342 14.8974 3.92199 13.9042C2.75058 12.911 1.93368 11.564 1.59442 10.0661C1.25516 8.56826 1.41192 7.00074 2.04106 5.59972C2.67021 4.1987 3.73766 3.04012 5.08256 2.29855C6.42746 1.55698 7.97695 1.27262 9.49756 1.4883C11.0145 1.70347 12.4206 2.40466 13.5052 3.48656L15.5832 5.44339V2.83339C15.5832 2.44218 15.9004 2.12505 16.2916 2.12505C16.6828 2.12505 16.9999 2.44218 16.9999 2.83339V7.08339C16.9999 7.47458 16.6828 7.79172 16.2916 7.79172H12.0416C11.6504 7.79172 11.3332 7.47458 11.3332 7.08339C11.3332 6.69218 11.6504 6.37505 12.0416 6.37505H14.5062L12.5264 4.51073C12.5212 4.50581 12.5161 4.50082 12.511 4.49576C11.6425 3.62671 10.515 3.06347 9.29858 2.89092Z"
                fill="#5D636F"
            />
        </svg>
    );
}

export default ReloadIcon;
